// extracted by mini-css-extract-plugin
export default {"box":"tSLqNsaazN_ITN6SR1DI","logo":"MzNHxVDV75Ty6g1pwYOH","collapseButton":"SzpTgNszLjKJW7QZ3tTJ","collapsed":"q0Pvn6M_mA8ncBpliWZy"};